// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2GGYW","notes":"Notes_notes__6SKJq","note":"Notes_note__3nJ1m","markdown":"Notes_markdown__19COi"};